module.exports = __webpack_public_path__ + "img/119.56f30f04.jpg";